const ul = document.getElementById("detail_app_hub_product_main_introduction_tab")
const header = document.getElementById("apphub-header")
if (ul) {
    let isScrollingByClick = false;
    const lis = ul.querySelectorAll("li");

    const anchors = Array.from(lis).map(li => {
        const id = li.dataset.title;
        return document.getElementById(id);
    }).filter(Boolean);

    function setActiveByScroll() {
        if (isScrollingByClick) return;
        const offset = getOffset();
        let currentId = "";
        let minDistance = Infinity;

        anchors.forEach(anchor => {
            const rect = anchor.getBoundingClientRect();
            const distance = Math.abs(rect.top - offset);
            if (rect.top - offset <= 0 && distance < minDistance) {
                minDistance = distance;
                currentId = anchor.id;
            }
        });

        if (currentId) {
            lis.forEach(li => {
                if (li.dataset.title === currentId) {
                    li.classList.add("detail_app_hub_product_main_introduction_tab_item_active");
                } else {
                    li.classList.remove("detail_app_hub_product_main_introduction_tab_item_active");
                }
            });
        }
    }

    ul.addEventListener("click", (e) => {
        window.e = e
        if (e.target.nodeName === "LI") { // 确保点击的是 li
            isScrollingByClick = true;
            setTimeout(() => {
                isScrollingByClick = false;
            }, 600); // 足够让 scroll 动画完成
            const lis = ul.querySelectorAll("li");
            lis.forEach(li => li.classList.remove("detail_app_hub_product_main_introduction_tab_item_active"));
            e.target.classList.add("detail_app_hub_product_main_introduction_tab_item_active");
            const title = e.target.dataset.title
            if (title) {
                const targetElement = document.getElementById(title)
                if (targetElement) {
                    const offset = 116;
                    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        }
    });

    function getOffset() {
        return window.innerWidth < 1200 ? 44 : 72;
    }

    const ulOriginTop = ul.offsetTop;

    function checkPosition() {
        ul.classList.remove("detail_app_hub_product_main_introduction_tab_fixed_mobile")
        const offset = getOffset();
        const mobile_fixed = offset === 44 ? "detail_app_hub_product_main_introduction_tab_fixed_mobile" : ""
        if (window.scrollY >= ulOriginTop - offset) {
            ul.classList.add(`detail_app_hub_product_main_introduction_tab_fixed`);
            header.style.boxShadow = "none"
            if (mobile_fixed) {
                ul.classList.add(mobile_fixed)
            }
        } else {
            ul.classList.remove(`detail_app_hub_product_main_introduction_tab_fixed`);
            header.removeAttribute('style');
        }
        setActiveByScroll()
    }

    // 监听滚动事件
    window.addEventListener('scroll', () => checkPosition(ul));
    // 页面加载时也检查位置
    window.addEventListener('load', () => checkPosition(ul));

    window.addEventListener('resize', checkPosition);
}

